'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import OffcanvasNavigationLayer from '@/src/app/components/OffCanvasNavigation/OffcanvasNavigationLayer/OffcanvasNavigationLayer';
import React, { SyntheticEvent, useState } from 'react';
import { NavigationNode } from '@/src/lib/navigation/type';
import { Dictionary } from '@/src/lib/dictionary/types';
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import { areEqualNavigationNodes, isActiveNavigationNode } from '@/src/lib/navigation/utils';
import { CatalogRequestParams } from '@/src/lib/category/types';
export type OffCanvasNavigationListItemProps = {
  navigationItem: NavigationNode;
  onCloseClick: () => void;
  dict: Dictionary;
  listType: 'primary' | 'secondary' | 'tertiary';
  lang: string;
  className?: string;
  targetNavigationItem?: NavigationNode;
  languageDropdown?: React.JSX.Element;
};
function OffCanvasNavigationListItem(t0) {
  const $ = _c(22);
  const {
    navigationItem,
    onCloseClick,
    dict,
    listType,
    lang,
    className,
    targetNavigationItem,
    languageDropdown
  } = t0;
  let t1;
  if ($[0] !== navigationItem || $[1] !== targetNavigationItem) {
    t1 = areEqualNavigationNodes(navigationItem, targetNavigationItem) ? [navigationItem] : [];
    $[0] = navigationItem;
    $[1] = targetNavigationItem;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [activeNodes, setActiveNodes] = useState(t1);
  const pathname = usePathname();
  let t2;
  if ($[3] !== activeNodes || $[4] !== onCloseClick) {
    t2 = function onNavItemClick(event, node) {
      if (!node.children?.length) {
        onCloseClick();
        return;
      }
      event.preventDefault();
      setActiveNodes([...activeNodes, node]);
    };
    $[3] = activeNodes;
    $[4] = onCloseClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onNavItemClick = t2;
  let t3;
  if ($[6] !== activeNodes) {
    t3 = function onBacklinkClick(_, node_0) {
      const nodeIndex = activeNodes.findIndex(activeNode => activeNode === node_0);
      setActiveNodes(activeNodes.splice(0, nodeIndex));
    };
    $[6] = activeNodes;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onBacklinkClick = t3;
  let t4;
  if ($[8] !== activeNodes || $[9] !== className || $[10] !== dict || $[11] !== lang || $[12] !== languageDropdown || $[13] !== listType || $[14] !== navigationItem || $[15] !== onBacklinkClick || $[16] !== onCloseClick || $[17] !== onNavItemClick || $[18] !== pathname) {
    const isActiveListItem = isActiveNavigationNode(navigationItem, pathname);
    const itemClassList = {
      primary: {
        label: "text-3xl font-bold mt-8 mb-3 group-[.is-first]:mt-3",
        link: classNames("text-3xl font-bold uppercase hover:text-white py-2.5", {
          "px-3 -ml-3 hover:!text-black": isActiveListItem
        })
      },
      secondary: {
        label: "text-base font-bold mt-8 mb-3 group-[.is-first]:mt-2",
        link: classNames("font-bold hover:!underline py-1.5", {
          "px-2 -ml-2 hover:!no-underline": isActiveListItem
        })
      },
      tertiary: {
        label: "text-base mt-8 mb-3 group-[.is-first]:mt-2",
        link: classNames("hover:!underline py-1.5", {
          "px-2 -ml-2 hover:!no-underline": isActiveListItem
        })
      }
    };
    let t5;
    if ($[20] !== className) {
      t5 = classNames("py-0.5", className);
      $[20] = className;
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    t4 = <li lang={lang === "en" ? "de" : lang} className={t5}>{navigationItem.nodeType === "label" ? <h2 className={classNames(itemClassList[listType].label, "uppercase tracking-widest hyphens-auto")}>{navigationItem.title}</h2> : <><Link href={navigationItem.url || ""} className={classNames("no-underline! inline-block hyphens-auto", itemClassList[listType].link, {
          "bg-primary-700": isActiveListItem
        })} onClick={e => onNavItemClick(e, navigationItem)} target={navigationItem.nodeType === "external_url" ? "_blank" : "_self"} aria-current={isActiveListItem ? CatalogRequestParams.PAGE : undefined}>{navigationItem.title}</Link>{navigationItem.children?.length && activeNodes.includes(navigationItem) ? <OffcanvasNavigationLayer navigationLayer={navigationItem} dict={dict} onBacklinkClick={onBacklinkClick} onNodeClick={onNavItemClick} activeNodes={activeNodes} onCloseClick={onCloseClick} languageDropdown={languageDropdown} /> : null}</>}</li>;
    $[8] = activeNodes;
    $[9] = className;
    $[10] = dict;
    $[11] = lang;
    $[12] = languageDropdown;
    $[13] = listType;
    $[14] = navigationItem;
    $[15] = onBacklinkClick;
    $[16] = onCloseClick;
    $[17] = onNavItemClick;
    $[18] = pathname;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
export default OffCanvasNavigationListItem;